import { Grid, Typography } from "@mui/material";
import { ContentWithMedia, GiftWithMedia } from "JS/Models";
import { styled } from "@mui/material/styles";

export interface PurchaseAndSkuInfoGridProps {
    content: ContentWithMedia | GiftWithMedia;
}

const Grey500Grid = styled(Grid)(({ theme }) => ({
    color: theme.palette.grey[500],
}));

const ConstMarginTypography = styled(Typography)(({ theme }) => ({
    marginRight: theme.spacing(2),
}));

export const PurchaseAndSkuInfoGrid = (props: PurchaseAndSkuInfoGridProps) => {
    const { content } = props;
    return (
        <Grey500Grid item xs={12} display="flex">
            {!content.isReceived &&
                !content.is_purchased &&
                content?.publish_free === "0" && (
                    <ConstMarginTypography fontWeight={"bold"} variant="body1">
                        {content.is_redeemable_by_tokens
                            ? `${content.number_of_tokens} Credit${
                                  +content?.number_of_tokens > 1 ? "s" : ""
                              }`
                            : ""}
                        {content.is_redeemable_by_tokens &&
                        content.content_price > 0.0
                            ? " | "
                            : ""}
                        {content.content_price > 0.0
                            ? (+content.content_price).toFixed(2)
                            : ""}
                    </ConstMarginTypography>
                )}
            <Typography variant="body1">{content.sku_id}</Typography>
        </Grey500Grid>
    );
};
